"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountSelectionDropDown = void 0;
var tslib_1 = require("tslib");
/* eslint-disable no-console */
var react_1 = tslib_1.__importStar(require("react"));
var asg_1 = require("@alinta-digital/asg");
var icons_1 = require("@alinta-digital/asg/icons");
var AccountSelectionDropDown_desktopTablet_1 = tslib_1.__importDefault(require("./AccountSelectionDropDown.desktopTablet"));
var AccountSelectionDropDown_mobile_1 = tslib_1.__importDefault(require("./AccountSelectionDropDown.mobile"));
var AccountSelectionDropDown_gql_1 = require("./AccountSelectionDropDown.gql");
var client_1 = require("@apollo/client");
var lodash_1 = require("lodash");
var AccountSelectionDropDown = function (_a) {
    var customerNumber = _a.customerNumber, onDropdownChange = _a.onDropdownChange, selectedFuelAccountId = _a.selectedFuelAccountId, displaySeeAllAccountOption = _a.displaySeeAllAccountOption, displayClosedAccounts = _a.displayClosedAccounts, toggleClosedIconColor = _a.toggleClosedIconColor, onError = _a.onError;
    var responsiveSize = (0, react_1.useContext)(asg_1.ResponsiveContext);
    var isMobileBreakpoint = responsiveSize === 'xs';
    var _b = (0, react_1.useState)(true), isFirstRender = _b[0], setIsFirstRender = _b[1];
    var _c = (0, react_1.useState)([]), fuelAccounts = _c[0], setFuelAccounts = _c[1];
    var _d = (0, react_1.useState)(''), selectedAccountId = _d[0], setSelectedAccountId = _d[1];
    var handleAccountSelection = function (value) {
        if (fuelAccounts.length && onDropdownChange) {
            var fuelAccount = fuelAccounts.filter(function (fuelAccount) { return fuelAccount.value === value; })[0];
            // might need to change this, sorting when selection changes
            onDropdownChange(fuelAccount);
        }
    };
    var sortByAddressThenFuelType = function (a, b) {
        // by address
        if (a.secondaryLabel < b.secondaryLabel)
            return -1;
        else if (a.secondaryLabel > b.secondaryLabel)
            return 1;
        // by fuel type
        if (a.label < b.label)
            return -1;
        else if (a.label > b.label)
            return 1;
        return 0;
    };
    var processAccs = function (accounts, accSelected) {
        // get accounts with the same address
        var accSameAd = accounts.filter(function (acc) { return acc.secondaryLabel === accSelected.secondaryLabel; });
        // get accounts with a different address
        var accDiffAd = accounts.filter(function (acc) { return acc.secondaryLabel !== accSelected.secondaryLabel; });
        // sort by fuel type then by address
        var accsDiff = [];
        accsDiff = accDiffAd.sort(sortByAddressThenFuelType);
        // concat
        var accs = [];
        if (accSameAd.length === 1) {
            accs = accsDiff;
            accs.filter(function (acc) { return acc.value !== accSelected.value; });
        }
        if (accSameAd.length > 1) {
            // remove selected account
            accSameAd = accSameAd.filter(function (acc) { return acc.value !== accSelected.value; });
            accSameAd = accSameAd.sort(sortByAddressThenFuelType);
            accs = accSameAd.concat(accsDiff);
        }
        return accs;
    };
    var processOpenAccs = function (accounts, accSelected) {
        // get accounts with the same address
        var accSameAd = accounts.filter(function (acc) { return acc.secondaryLabel === accSelected.secondaryLabel; });
        // get accounts with a different address
        var accDiffAd = accounts.filter(function (acc) { return acc.secondaryLabel !== accSelected.secondaryLabel; });
        // sort by fuel type then by address
        var accsDiff = [];
        accsDiff = accDiffAd.sort(sortByAddressThenFuelType);
        return accSameAd.concat(accsDiff);
    };
    var sortAccountsOpen = function (accounts, accSelected) {
        var accs = processOpenAccs(accounts, accSelected);
        if (accSelected.status === 'closed') {
            return accs;
        }
        return accs;
    };
    var sortAccountsClosed = function (accounts, accSelected) {
        if (accSelected.status === 'closed') {
            var accs = processAccs(accounts, accSelected);
            return [accSelected].concat(accs);
        }
        return accounts.sort(sortByAddressThenFuelType);
    };
    var _e = (0, client_1.useLazyQuery)(AccountSelectionDropDown_gql_1.CUSTOMER_ACCOUNT_QUERY, {
        onCompleted: function (response) {
            var _a, _b;
            var emailAddress = response.profile.customer.contacts.filter(function (contact) {
                return contact.type.includes('emailprimary');
            });
            var unfilteredAccounts = (_a = response.profile) === null || _a === void 0 ? void 0 : _a.customerAccounts;
            // https://jira.alintaenergy.com.au/browse/SSC-3291 (filters the list to avoid duplicate account entry)
            var accs = (0, lodash_1.uniqBy)(unfilteredAccounts, 'accountId');
            //dormant accounts
            accs = accs.filter(function (acc) { return acc.dormant !== true; });
            if (!displayClosedAccounts) {
                accs = accs.filter(function (acc) { return acc.accountStatus !== 'closed'; });
                if (accs.length < 1) {
                    return;
                }
            }
            var accountsList = accs.map(function (acc) {
                var _a, _b;
                var FuelIcon = null;
                if (toggleClosedIconColor && acc.accountStatus === 'closed') {
                    FuelIcon = (react_1.default.createElement(asg_1.Icon, { id: acc.fuel === 'electricity' ? 'elec' : 'gas', icon: acc.fuel === 'electricity' ? icons_1.Electricity : icons_1.Gas, height: '23px', width: 'auto', css: { '.fill': { fill: asg_1.colors['light-4'] } } }));
                }
                else {
                    FuelIcon =
                        acc.fuel === 'electricity' ? (react_1.default.createElement(asg_1.Icon, { id: 'elec', icon: icons_1.Electricity, height: '23px', width: 'auto' })) : (react_1.default.createElement(asg_1.Icon, { id: 'gas', icon: icons_1.Gas, height: '23px', width: 'auto' }));
                }
                return {
                    value: acc.accountId,
                    label: acc.fuel,
                    secondaryLabel: acc.utilityAddress.computedAddress,
                    deemphasized: true,
                    icon: FuelIcon,
                    paymentRegion: acc.utilityAddress.state,
                    emailAddress: (_b = (_a = emailAddress[0]) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                    status: acc.accountStatus === 'closed' ? 'closed' : 'open',
                };
            });
            var accountIndex = '';
            var firstActiveAccount = accountsList.filter(function (x) { return x.status !== 'closed'; });
            accountIndex = firstActiveAccount.length > 0 ? (_b = firstActiveAccount[0]) === null || _b === void 0 ? void 0 : _b.value : accountsList[0].value;
            var accountId = selectedFuelAccountId && selectedFuelAccountId.length > 0 ? selectedFuelAccountId : accountIndex;
            setSelectedAccountId(accountId);
            if (isFirstRender) {
                if (accountsList.length && onDropdownChange) {
                    var fuelAccount = accountsList.filter(function (fuelAccount) { return fuelAccount.value === accountId; })[0];
                    onDropdownChange(fuelAccount);
                    // separate into closed and open accounts
                    var accsOpen = accountsList.filter(function (acc) { return acc.status === 'open'; });
                    var accsClosed = accountsList.filter(function (acc) { return acc.status === 'closed'; });
                    // sort open accounts
                    var accsOpenSorted = sortAccountsOpen(accsOpen, fuelAccount);
                    // sort closed accounts
                    var accsClosedSorted = sortAccountsClosed(accsClosed, fuelAccount);
                    // concat closed accounts into open accounts
                    var accsFinal = accsOpenSorted.concat(accsClosedSorted);
                    if (displaySeeAllAccountOption && accsFinal.length > 1)
                        accsFinal.push({
                            value: 'link',
                            label: 'See all accounts',
                            secondaryLabel: '',
                            deemphasized: false,
                            paymentRegion: '',
                            emailAddress: '',
                            status: '',
                        });
                    // move the selected account at the top
                    var index = accsFinal.findIndex(function (x) { return x.value === accountId; });
                    if (index !== -1) {
                        accsFinal.unshift(accsFinal.splice(index, 1)[0]);
                    }
                    setFuelAccounts(accsFinal);
                }
                setIsFirstRender(false);
            }
        },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onError: function () {
            if (onError)
                onError();
        },
        fetchPolicy: 'cache-first',
    }), getCustomerAccounts = _e[0], error = _e[1].error;
    (0, react_1.useEffect)(function () {
        getCustomerAccounts({ variables: { customerAccount: customerNumber } });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (isMobileBreakpoint && fuelAccounts.length > 0)
        return (react_1.default.createElement(AccountSelectionDropDown_mobile_1.default, { fuelAccounts: fuelAccounts, onDropdownChange: function (value) {
                handleAccountSelection(value);
            }, selectedFuelAccountId: selectedAccountId, initialLoad: isFirstRender, displayMultiLineSelectedItem: true }));
    if (fuelAccounts.length > 0)
        return (react_1.default.createElement(AccountSelectionDropDown_desktopTablet_1.default, { initialLoad: isFirstRender, fuelAccounts: fuelAccounts, onDropdownChange: function (value) {
                handleAccountSelection(value);
            }, selectedFuelAccountId: selectedAccountId }));
    return react_1.default.createElement("div", { "data-testid": error ? 'errorState' : 'emptyState' });
};
exports.AccountSelectionDropDown = AccountSelectionDropDown;
//# sourceMappingURL=AccountSelectionDropDown.js.map